export const FETCH_RUNPAYROLL_DATA = 'FETCH_RUNPAYROLL_DATA';
export const FETCH_RX_BALANCE = 'FETCH_RX_BALANCE';
export const FETCH_BALANCE = 'FETCH_BALANCE';
export const FETCH_ARREARS = 'FETCH_ARREARS';
export const FETCH_COMPLIANCE_ARREARS = 'FETCH_COMPLIANCE_ARREARS';
export const FETCH_LOP_AMOUNT = 'FETCH_LOP_AMOUNT';
